import { object, string } from 'yup';

import { isValidCNPJ, onlyNumbers } from '@brazilian-utils/brazilian-utils';

export const schemaDadosCliente = object({
  cnpj: string()
    .required('Esse campo é obrigatório')
    .test('test-invalid-cnpj', 'CNPJ inválido', cnpj => isValidCNPJ(onlyNumbers(cnpj))),
});
